import React from 'react';
import { Box, Typography } from '@mui/material';


const Footer = () => (
  <Box mt="80px" bgcolor="#7FB77E">

    <Typography variant="h5" sx={{ fontSize: { lg: '28px', xs: '20px' } }} mt="41px" textAlign="center" pb="40px">Global Elite❤️</Typography>
  </Box>
);

export default Footer;
